import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import slugify from "react-slugify";
import { toast } from "react-toastify";
import { isFinance } from "../../../helper/is_finance";

export default function useFinance(vehicle: any) {
  const [firedWarning, setFiredWarning] = useState(false)
  const router = useRouter();

  // redirect user if the vehicle does't contain finance data
  useEffect(() => {
    if (!firedWarning && vehicle) {
      if (router.isReady && !isFinance(vehicle)) {
        if (!firedWarning) {
          toast.warning('This vehicle is not eligable for finance')
          setFiredWarning(true)
        }

        router.push('/finance/all')
      }
    }
  }, [vehicle, router, firedWarning])
}

